<section [ngClass]="dynamicClass">
  <div
    class="eq-container eq-w-[358px] sm:eq-w-2/3 lg:eq-w-[77%] eq-flex eq-flex-col eq-justify-center eq-gap-y-6 lg:eq-gap-y-[59px]"
  >
    <h2 *ngIf="rendering.fields?.Title?.value"
      class="eq-text-heading2-m eq-font-bold eq-text-blue-darkBlue eq-py-[3px] eq-text-center lg:eq-text-start lg:eq-text-heading2 lg:eq-max-w-[710px]"
    >
      {{ rendering.fields?.Title?.value }}
    </h2>
    <div *ngIf="cards.length > 0">
      <app-accordion-item [data]="item" *ngFor="let item of cards"></app-accordion-item>
    </div>
    <div class="eq-flex eq-justify-center">
      <button type="button" class="eq-btn eq-btn-secondary" (click)="showMore($event)">{{rendering.fields?.ButtonLabel?.value}}</button>
    </div>
  </div>
</section>